import { render } from "./TemplateStorageExample.vue?vue&type=template&id=0fa99bb9&scoped=true&ts=true"
import script from "./TemplateStorageExample.vue?vue&type=script&lang=ts"
export * from "./TemplateStorageExample.vue?vue&type=script&lang=ts"

import "./TemplateStorageExample.vue?vue&type=style&index=0&id=0fa99bb9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fa99bb9"]])

export default __exports__